import { defineComponent, ref, onMounted } from "vue";
import { Product, Category } from "@app/types/index";

import { MenuProductCard } from "./MenuProductCard";
import { useMenu } from "../../providers";

export type MenuListProps = {
  categories: Category[];
  products: Product[];
  onProductSelect: (product: Product) => void;
  onCategoryChange: (id: number) => void;
};
export const MenuList = defineComponent<MenuListProps>({
  name: "MenuList",
  props: ["categories", "products", "onProductSelect", "onCategoryChange"],
  setup(props, { emit }) {
    const activeCategory = ref<string | null>(null);
    const { cart, allServices, promotions } = useMenu();
    onMounted(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const categoryId = entry.target.getAttribute("data-category");
              if (categoryId) {
                activeCategory.value = categoryId;
                emit("category-change", categoryId);
                props.onCategoryChange(parseInt(categoryId));
              }
            }
          });
        },
        { threshold: 0.2 },
      );

      props.categories.forEach((category) => {
        const element = document.querySelector(
          `[data-category="${category.id}"]`,
        );
        if (element) observer.observe(element);
      });
    });

    return () => (
      <>
        <div class="flex flex-col gap-8 pb-20 pt-6 bg-base-100">
          {props.categories.map((category) => (
            <section
              key={category.id}
              data-category={category.id}
              class="scroll-mt-32"
            >
              <h2 class="text-2xl text-accent text-left uppercase py-6 px-4">
                {category.name}
              </h2>
              <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-t lg:border-t-0 lg:gap-5 lg:px-4">
                {props.products
                  .filter((product) =>
                    category.product_ids.includes(product.id),
                  )
                  .map((product, i) => {
                    return (
                      <MenuProductCard
                        key={product.id}
                        product={product}
                        onProductSelect={props.onProductSelect}
                        cartItems={cart.cart.items}
                        services={allServices.value}
                        promotions={promotions.value}
                      />
                    );
                  })}
              </div>
            </section>
          ))}
        </div>
      </>
    );
  },
});
